import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiRequestService } from '../services/api-request.service';
import { AuthService } from '../services/auth.service';
import { LoggedInUserService } from '../services/logged-in-user.service';

@Injectable({
    providedIn: 'root'
})
export class AuthorizedGuardRolesService implements CanActivate {
    constructor(
        public router: Router,
        private authService: AuthService,
        private cookies: CookieService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private loggedInUserService: LoggedInUserService,
        private apiRequestService: ApiRequestService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.getUserRole() && this.getUserRole().trim() !== '') {
            return this.seePagesBasedOnRole(route.routeConfig.path, route.queryParams['status']);
        } else {
            localStorage.setItem('redirectUrl', window.location.href);
            return false;
        }
    }
    getLoggedUserId() {
        if (isPlatformBrowser(this.platformId)) {
            return this.cookies.get('userId');
        } else {
            return null;
        }
    }
    getClientUserId() {
        if (isPlatformBrowser(this.platformId)) {
            return this.cookies.get('clientId');
        } else {
            return null;
        }
    }
    getTicketClientUserId() {
        if (isPlatformBrowser(this.platformId)) {
            return this.cookies.get('ticketClientId');
        } else {
            return null;
        }
    }
    getUserRole() {
        if (isPlatformBrowser(this.platformId)) {
            return this.cookies.get('userRole');
        } else {
            return null;
        }
    }
    seePagesBasedOnRole(path, params) {
        const accessCheck = condition => this.checkUserHasAccess(condition);
        switch (path) {
            case 'strategy':
            case 'serviceCatalog':
                return accessCheck(!this.loggedInUserService.isAccountMangerOrRequester());

            case ':userPath/dashboard':
                return accessCheck(this.loggedInUserService.canSeeDashboard());
            case ':userPath/callRecordDashboard':
                return accessCheck(this.loggedInUserService.canSeeCallRecordDashboard());
            case ':userPath/callRecord':
            case ':userPath/:requestPath/create-record':
            case ':userPath/:requestPath/view-record':
                return accessCheck(this.loggedInUserService.isDisplayCallRecord());

            case 'empolyee-managment':
                return accessCheck(this.loggedInUserService.isDisplaySeenEmployeeManagement());

            case 'client-management-users':
                return accessCheck(this.loggedInUserService.isAccountMangerInquires() || this.loggedInUserService.isAccountMangertBoth());

            case 'ticketing':
                return accessCheck(this.loggedInUserService.canAccessMessageCenter());
            case 'message-center':
                return accessCheck(this.loggedInUserService.canAccessMessageCenter());

            case 'data-management':
                return accessCheck(this.loggedInUserService.isSuperAdmin());

            case 'file-management':
                return accessCheck(this.loggedInUserService.isInternalUser());
            case 'periodic-review':
                return accessCheck(this.loggedInUserService.isInternalUser());
            case 'delegation':
                return accessCheck(this.loggedInUserService.getUserActiveDelegation());
            case 'call-center-client-management':
                return accessCheck(this.loggedInUserService.IsUserRelatedQualityAssurance());

            case 'services':
                if (this.getTicketClientUserId() != undefined && this.getTicketClientUserId() != null) {
                    if (['ALL_SERVICES', 'teamServices', 'needMyApproval'].includes(params)) {
                        return accessCheck(this.loggedInUserService.isApprovalUser());
                    } else if (['assignedToMeForServiceManagement', 'notAssignedForServiceManagement', 'resolvedByMeForServiceManagement'].includes(params)) {
                        return accessCheck(this.loggedInUserService.isResolutionTeam());
                    } else {
                        return accessCheck(true);
                    }
                } else {
                    return accessCheck(false);
                }

            case 'account-manager':
            case 'requester':
            case 'employee':
            case 'manager':
            case 'admin':
            case ':userPath/:requestPath/request':
            case ':userPath/:requestPath/create-request':
                return accessCheck(!this.loggedInUserService.cannotSeeInquiries() && this.getClientUserId() != undefined && this.getClientUserId() != null);

            default:
                return false;
        }
    }

    checkUserHasAccess(check): boolean {
        if (check) {
            return true;
        } else {
            this.router.navigate(['NotAthorizedPageComponent']);
            return false;
        }
    }
}
